import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-订单管理",
  "use": "d2-订单管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"d2-订单管理\"><defs><style type=\"text/css\"></style></defs><path d=\"M112.3 65.6v936.8l193.9-123.9L512 1004.4l205.8-125.8 193.9 123.9V65.6H112.3z m709.4 772.6l-55.4-35.4-47.4-30.3-48 29.3L512 898.9l-158.8-97.1-48-29.3-47.4 30.3-55.4 35.4V155.6h619.3v682.6zM692 405.2H332v-90h360v90z m0 210.2H332v-90h360v90z\" p-id=\"11830\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol